import { useAtom } from 'jotai';
import { useCallback } from 'react';

import { PinsAccountData, initialPinsAccountState, pinsAtom } from '@/store';

const usePinsAccount = () => {
  const [pinsData, setPinsData] = useAtom(pinsAtom);

  const updatePinsData = useCallback(
    (updates: Partial<PinsAccountData>) => {
      setPinsData((prev) => ({
        ...prev,
        ...updates,
      }));
    },
    [setPinsData]
  );

  const handleSetPinsData = useCallback(
    (data: PinsAccountData) => {
      setPinsData(data);
    },
    [setPinsData]
  );

  const handleResetPinsData = useCallback(() => {
    setPinsData(initialPinsAccountState);
  }, [setPinsData]);

  return {
    pinsData,
    handleSetPinsData,
    updatePinsData,
    handleResetPinsData,
  };
};

export default usePinsAccount;
